/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_PRESENTATIONS } from "../graphql";

const is = require("is_js");
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetPresentationListsMethods extends IPluginMethodMap {
  getPresentationLists(args: any): Promise<any>;
}

export class GetPresentationListsService implements IAgentPlugin {
  readonly methods: IGetPresentationListsMethods;

  constructor() {
    this.methods = {
      getPresentationLists: this.getPresentationLists.bind(this),
    };
  }

  async getPresentationLists(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: {
              year: {
                eq: "2024",
              },
              status: {
                eq: "active",
              },
            },
          },
          fetchPolicy: "network-only",
        });

        if (
          res?.data?.getPresentations?.content &&
          is.not.empty(res?.data?.getPresentations?.content)
        ) {
          for (let obj of res?.data?.getPresentations?.content) {
            if (obj && is.not.empty(obj)) {
              const payload = this.formatData(obj);
              obj.sections = payload;
            }
          }

          if (
            res?.data?.getPresentations?.content &&
            is.not.empty(res?.data?.getPresentations?.content) &&
            !res?.data?.getPresentations?.content.some((e: any) => e.id === "")
          ) {
            res?.data?.getPresentations?.content.unshift({
              name: "...",
              id: "",
              sections: [
                {
                  name: "...",
                  id: "",
                  costumeTypes: [
                    {
                      name: "...",
                      id: "",
                    },
                  ],
                },
              ],
            });
          }

          return res?.data?.getPresentations;
        } else {
          return [];
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private formatData(data: any) {
    let sectionList: any = [
      {
        name: "...",
        id: "",
        costumeTypes: [{ name: "...", id: "" }],
      },
    ];

    for (let obj of data?.sections) {
      if (obj && is.not.empty(obj)) {
        let costumeList: any = [{ name: "...", id: "" }];

        for (let costumeObj of obj?.costumeTypes) {
          if (costumeObj && is.not.empty(costumeObj) && costumeObj?.isVisible) {
            costumeList.push(costumeObj);
          }
        }
        obj.costumeTypes = costumeList;

        if (obj?.isVisible) {
          sectionList.push(obj);
        }
      }
    }

    return sectionList;
  }
}
